import { Signal } from "signals";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiText from "slotworks/graphics/elements/flexi-text";

export default class RadioGroup<T> {

    public onChange: Signal;

    private buttons: FlexiButton[];
    private buttonListeners: Array<() => void>;
    private labels: FlexiText[];

    private prevButton: FlexiButton;
    private nextButton: FlexiButton;

    private values: T[];

    private viewPointer: number;
    private selectedIndex: number;

    constructor(buttons: FlexiButton[], values: T[], defaultValue: T, labels: FlexiText[], prevButton: FlexiButton, nextButton: FlexiButton) {
        this.onChange = new Signal();

        this.buttons = buttons;
        this.labels = labels;

        this.prevButton = prevButton;
        this.nextButton = nextButton;

        this.prevButton.on(ButtonEvent.POINTER_DOWN, this.prev);
        this.nextButton.on(ButtonEvent.POINTER_DOWN, this.next);

        this.values = values;

        this.selectedIndex = this.values.indexOf(defaultValue);
        this.viewPointer = Math.min(buttons.length, Math.max(0, this.selectedIndex - Math.floor(buttons.length / 2)));

        this.buttonListeners = [];
        for (let viewPosition = 0; viewPosition < this.buttons.length; viewPosition++) {
            const button = this.buttons[viewPosition];
            const listener = () => { this.buttonPressed(viewPosition); };
            this.buttonListeners.push(listener);
            button.setEnabled(true);
            button.on(ButtonEvent.POINTER_DOWN, listener);
        }

        this.update();
    }

    public destroy() {
        for (let viewPosition = 0; viewPosition < this.buttons.length; viewPosition++) {
            this.buttons[viewPosition].off(ButtonEvent.POINTER_DOWN, this.buttonListeners[viewPosition]);
        }

        this.prevButton.off(ButtonEvent.POINTER_DOWN, this.prev);
        this.nextButton.off(ButtonEvent.POINTER_DOWN, this.next);

        this.onChange.removeAll();
    }

    private next = () => {
        this.viewPointer++;

        if (this.viewPointer > this.values.length - this.buttons.length) {
            this.viewPointer = this.values.length - this.buttons.length;
        }

        this.update();
    }

    private prev = () => {
        this.viewPointer--;

        if (this.viewPointer < 0) {
            this.viewPointer = 0;
        }

        this.update();
    }

    private update() {
        for (let viewPosition = 0; viewPosition < this.labels.length; viewPosition++) {
            const listPosition = viewPosition + this.viewPointer;

            this.buttons[viewPosition].setSelected(false);
            if (listPosition === this.selectedIndex) {
                this.buttons[viewPosition].setSelected(true);
            }

            this.labels[viewPosition].setText(this.values[listPosition].toString());
        }
    }

    private buttonPressed(viewPosition: number) {
        this.selectedIndex = this.viewPointer + viewPosition;

        this.onChange.dispatch(this.values[this.selectedIndex]);

        this.update();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/ui/radio-group.ts